import { put, takeEvery } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import routes from 'Pages/router/constants/routes';
import walletPaymentServices from './services';
import { SAGA_REQUEST_KEY } from 'Constants';
import walletPaymentActions from './actions';
import walletPaymentTypes from './types';
import { messageActions } from 'Ducks';

function* newTransactionRequest(action) {
	try {
		let response = yield sagaCallService(
			walletPaymentServices.newTransaction,
			action,
			action.payload
		);
		const { amount } = action.payload;
		const { id } = response.data;
		yield put(walletPaymentActions.newTransactionSuccess({ amount, id }));
		if (action.payload?.navigate) {
			action.payload.navigate(routes.paymentInformation);
		}
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			walletPaymentActions.newTransactionFailure
		);
		if (action.payload?.[SAGA_REQUEST_KEY.DISABLE_TOAST]) {
			yield put(
				messageActions.pushErrorToast({
					title: e.message || 'خطایی در تراکنش رخ داده است',
				})
			);
		}
	}
}
function* barcodeCheckRequest(action) {
	try {
		yield sagaCallService(
			walletPaymentServices.barcodeCheck,
			action,
			action.payload
		);
		yield put(walletPaymentActions.checkBarcodeSuccess());
		if (action.payload?.navigate) {
			action.payload.navigate(routes.transactionStatus);
		}
	} catch (e) {
		const errorMessage = e?.response?.data?.msg;

		if (errorMessage === 'موجودی کیف پول کاربر کافی نیست') {
			yield put(
				walletPaymentActions.insufficientBalance(
					'موجودی کیف پول مشتری کافی نیست!'
				)
			);
		} else {
			yield put(walletPaymentActions.generalError(errorMessage));
		}
		yield sagaErrorDispatcher(
			e,
			action,
			walletPaymentActions.barcodeCheckFailure
		);
	}
}
function* getWalletTransactionList(action) {
	try {
		let response = yield sagaCallService(
			walletPaymentServices.TransactionReport,
			action,
			action.payload
		);

		yield put(walletPaymentActions.walletTransactionSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			walletPaymentActions.walletTransactionFailure
		);
	}
}

const walletPaymentSagas = [
	takeEvery(walletPaymentTypes.NEW_TRANSACTION.REQUEST, newTransactionRequest),
	takeEvery(walletPaymentTypes.CHECK_BARCODE.REQUEST, barcodeCheckRequest),
	takeEvery(
		walletPaymentTypes.WALLET_TRANSACTION.REQUEST,
		getWalletTransactionList
	),
];

export default walletPaymentSagas;
